export default __webpack_public_path__ + "static/media/excel.68492c06.svg";